import { useForm } from 'react-hook-form';
import Input from './atoms/Input';
import Select from './atoms/Select/Select';
import Button from './atoms/Button';
import { useCreateEventCashRegisterMovementMutation } from '../store/apis/events';
import { toastSuccess, toastError } from '../utils/toasts';

interface FormData {
  amount: number;
  type: string;
}

interface Props {
  eventId: string;
  businessId: string;
  cashRegisterId: string;
  sessionId: string;
  onClose: () => void;
}

const CreateEditCashMovement = ({
  eventId, businessId, cashRegisterId, sessionId, onClose,
}: Props) => {
  const { register, handleSubmit } = useForm<FormData>({
    defaultValues: { type: 'float_out' },
  });
  const [createEventCashRegisterMovement, { isLoading }] = useCreateEventCashRegisterMovementMutation();
  const onSubmit = async (data: FormData) => {
    try {
      const amount = data.type === 'float_out' ? -Math.abs(data.amount) : Math.abs(data.amount);
      await createEventCashRegisterMovement({
        businessId,
        eventId,
        cashRegisterId,
        sessionId,
        movementData: {
          amount,
          type: data.type,
        },
      }).unwrap();
      toastSuccess('Movimiento registrado correctamente');
      onClose();
    } catch (e) {
      toastError('Error al registrar el movimiento');
    }
  };

  const options = [
    { label: 'Ingreso de efectivo', value: 'float_in' },
    { label: 'Retiro de efectivo', value: 'float_out' },
  ];

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4">
      <Input id='amount' label='Monto *' labelAbove {...register('amount')} />
      <Select id='type' label='Tipo *' options={options} {...register('type')} />
      <div className="flex gap-2">
        <Button type="button" variant="secondary" onClick={onClose}>Cancelar</Button>
        <Button type="submit" loading={isLoading}>Guardar</Button>
      </div>
    </form>
  );
};

export default CreateEditCashMovement;
